import React from 'react';
import './LogoBar.css';

const logos = [
  { src: '/assets/logo/allergan.png', alt: 'Allergan' },
  { src: '/assets/logo/Galderma_Logo.png', alt: 'Galderma' },
  { src: '/assets/logo/merz.png', alt: 'Merz' },
  { src: '/assets/revanesse.png', alt: 'Revanesse' },
  { src: '/assets/logo/evolus-logo.png', alt: 'Evolus' },
  { src: '/assets/logo/freshclinics-logo.png', alt: 'Fresh Clinics' },
];


const LogoBar = () => {
  return (
    <section className="logobar">
      <div className="logobar-inner">
        <div className="logobar-track">
          {[...logos, ...logos].map((logo, i) => (
            <div className="logobar-item" key={i}>
              <img src={logo.src} alt={logo.alt} />
            </div>
          ))}
        </div>
      </div>

      {/* Consultation CTA */}

    </section>
  );
};

export default LogoBar;
